export const TABLE_STYLES = {
  COLORS: {
    HEADER_BG: '#f5f5f5',
    DURATION_BG: '#e0f7fa',
    ODD_ROW_BG: '#f9f9f9',
    HOVER_BG: '#e0f7fa',
    REQUIRED: '#D32F2F',
    NOT_REQUIRED: '#13B887',
    BASE_TEXT: '#0D465F',
  },
};

export const FORM_STYLES = {
  COLORS: {
    BACKGROUND: '#fff',
  },
};

export const TEXT_STYLES = {
  COLORS: {
    TEXT_LIGHT: '#ffffff',
    TEXT_DARK: '#0D465F',
    TEXT_LIGHTER: '#487386',
    TEXT_PRIMARY: '#17c586',
    TEXT_PRIMARY_HOVER: '#1BE29A',
  },
};

export const MULTIROW_HEIGHT = 100;
export const SINGLE_ROW_HEIGHT = 55;
